import SpriteSymbol from "../../../../../../../node_modules/normacs_web/node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../../../../node_modules/normacs_web/node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "status--project",
  "use": "status--project-usage",
  "viewBox": "0 0 64 64",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 64 64\" id=\"status--project\">\n  <path fill=\"#009DDC\" fill-rule=\"nonzero\" d=\"M32 56C18.745 56 8 45.255 8 32S18.745 8 32 8s24 10.745 24 24-10.745 24-24 24zm-13.692-9.692l8.836-.988a1 1 0 0 0 .596-1.701l-6.744-6.744a1 1 0 0 0-1.7.596l-.988 8.837zM42.58 19.58a4 4 0 0 0-5.656 0L22.253 34.253l7.778 7.778L44.703 27.36a4 4 0 0 0 0-5.657L42.58 19.58z\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol